export default __webpack_public_path__ + "static/media/shape3.0b761655.svg";